import { render } from "./assessment.vue?vue&type=template&id=6bcb2dbc"
import script from "./assessment.vue?vue&type=script&lang=js"
export * from "./assessment.vue?vue&type=script&lang=js"
script.render = render

export default script